import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GoogleAnalytics from 'react-ga';
import { setAppInitialized } from './actions/configActions';

class GoogleAnalyticsInitialize extends React.Component {
  componentDidUpdate() {
    this.initialize();
  }

  initialize() {
    const { config } = this.props;
    if (config && !config.appInitialized) {
      const analyticsID = config.analytics_id;
      GoogleAnalytics.initialize(analyticsID);
      this.props.setAppInitialized(true);
    }
  }

  render() {
    return <div />;
  }
}

GoogleAnalyticsInitialize.propTypes = {
  config: PropTypes.shape({}),
  setAppInitialized: PropTypes.func.isRequired
};

GoogleAnalyticsInitialize.defaultProps = {
  config: null
};

const mapStateToProps = state => ({
  config: state.config.data
});

const mapDispatchToProps = dispatch => ({
  setAppInitialized: value => dispatch(setAppInitialized(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleAnalyticsInitialize);



// WEBPACK FOOTER //
// ./src/GoogleAnalyticsInitialize.js